import React from 'react';
import { useIntl } from 'react-intl';

import SectionRoot from './styles/SectionRoot';
import CardImageBlock from './styles/CardImageBlock';

function CardBannerSection() {
  const { formatMessage } = useIntl();
  return (
    <SectionRoot>
      <CardImageBlock
        imageHeight="100%"
        imageWidth="100%"
        backgroundImage="pj-man-holding-business-card/pj-man-holding-business-card.jpg"
        alt={formatMessage({ id: 'BUSINESS_ACCOUNT.CARD_BANNER.IMAGE_ALT' })}
      />
    </SectionRoot>
  );
}

export default React.memo(CardBannerSection);
